import React, { createContext, useState, useEffect } from 'react';

export const PlatformContext = createContext();

export const PlatformProvider = ({ children }) => {
  const [platform, setPlatform] = useState(null);
  const [deviceType, setDeviceType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Enhanced mobile/tablet detection
    const detectPlatform = () => {
      const userAgent = navigator.userAgent;
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      // Enhanced detection for tablets including iPad Pro
      const isTablet = 
        /iPad|Android.*Tablet|tablet/i.test(userAgent) ||
        (navigator.maxTouchPoints > 1 && screenWidth >= 768 && screenWidth <= 1366) ||
        (screenWidth >= 768 && screenWidth <= 1366 && screenHeight >= 1024);

      const isPhone = 
        /iPhone|iPod|Android(?!.*Tablet)/i.test(userAgent) ||
        (screenWidth < 768 && navigator.maxTouchPoints > 1);

      const isMobile = isTablet || isPhone;

      let detectedDeviceType = 'desktop';
      let detectedPlatform = 'desktop';

      if (isMobile) {
        detectedPlatform = 'mobileWeb';
        if (isTablet) {
          detectedDeviceType = 'tablet';
        } else {
          detectedDeviceType = 'phone';
        }
      }

      return { platform: detectedPlatform, deviceType: detectedDeviceType };
    };

    const { platform: detectedPlatform, deviceType: detectedDeviceType } = detectPlatform();
    setPlatform(detectedPlatform);
    setDeviceType(detectedDeviceType);
    setLoading(false);
  }, []);

  return (
    <PlatformContext.Provider value={{ platform, deviceType, loading }}>
      {children}
    </PlatformContext.Provider>
  );
};
